<template>
	<Teleport to="body" v-if="enabled"><div class="chat-client" id="chat-client"></div></Teleport>
</template>

<script setup lang="ts">
import {ref, computed, onMounted} from "vue";
import {ChatClient} from "@/chat/ChatClient.ts";
import {injectEnv} from "@fd/Environment.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";

const enabled = computed<boolean>(() => {
	return !!Server.mod.chat;
});

const env = injectEnv();
const ns = useNavigationStore();

onMounted(() => {
	const chatClient = new ChatClient($("#chat-client"), env.user.login, () => {
		console.log("Chat context is "+JSON.stringify(ns.chatContext));
		return ns.chatContext;
	});
});
</script>

<style>

</style>